// Fast Simon Analytics Tracking
(function() {
  // console.log('Fast Simon Analytics script loaded');
  
  let isInitialized = false;
  let trackedImpressions = new Set();
  let isTrackingAddToCart = false;
  let trackingTimeout = null;
  let lastAddedProduct = null;


  // Track widget impressions
  function trackWidgetImpressions(event) {
    try {
      const { widgetType, productId, productData, sourceProductId } = event.detail;
      
      const impressionKey = `impression-${widgetType}-${productId}`;
      
      if (trackedImpressions.has(impressionKey)) {
        // console.log('Product already tracked:', impressionKey);
        return;
      }
      
      trackedImpressions.add(impressionKey);
      // console.log('Tracking new impression:', impressionKey);

      const eventData = {
        widget_type: widgetType,
        source_product_id: sourceProductId || 'n/a',
        product_id: productId || 'n/a',
        product_title: productData.title || 'n/a',
        product_price: productData?.price || 0,
        timestamp: new Date().toISOString()
      };
      
      // console.log('Publishing widget impression:', eventData);
      Shopify.analytics.publish('fast_simon_widget_impression', eventData);
    } catch (error) {
      console.error('Error in widget impression tracking:', error);
    }
  }

  // Track product selection
  // function trackProductSelection(event) {
  //   try {
  //     const { widgetType, sourceProductId, selectedProductId } = event.detail;
      
  //     // // Validate required fields
  //     // validateRequiredFields({ widgetType, sourceProductId, selectedProductId }, ['widgetType', 'sourceProductId', 'selectedProductId']);
      
  //     const selectionKey = `selection-${widgetType}-${sourceProductId}-${selectedProductId}`;
      
  //     if (trackedImpressions.has(selectionKey)) return;
  //     trackedImpressions.add(selectionKey);

  //     const eventData = {
  //       ecommerce: {
  //         widget_type: widgetType,
  //         source_product_id: sourceProductId || 'n/a',
  //         selected_product_id: selectedProductId || 'n/a',
  //         timestamp: new Date().toISOString()
  //       }
  //     };
  //     Shopify.analytics.publish('fast_simon_product_selection', eventData);
  //   } catch (error) {
  //     console.error('Error in product selection tracking:', error);
  //   }
  // }

  // Track add to cart
  async function trackAddToCart(event) {
    if (isTrackingAddToCart) {
      return;
    }
    
    if (trackingTimeout) {
      clearTimeout(trackingTimeout);
    }

    isTrackingAddToCart = true;
    trackingTimeout = setTimeout(async () => {
      try {
        const { productId, quantity, price, sourceProductId, productType, widgetType, title } = event.detail;

        // Store last added product for upsell click source tracking
        lastAddedProduct = { id: productId, title: title };

        // Get current cart state
        const response = await fetch('/cart.js');
        if (!response.ok) throw new Error(`Cart fetch failed: ${response.status}`);
        const cart = await response.json();
        
        const cartValueAfter = cart.total_price / 100;
        const addedProductPrice = price || 0;
        const addedProductQuantity = quantity || 1;
        const cartValueBefore = cartValueAfter - (addedProductPrice * addedProductQuantity);
        const revenueAttributed = addedProductPrice * addedProductQuantity;  
        const eventData = {
          widget_type: String(widgetType || 'upsell'),
          source_product_id: String(sourceProductId),
          added_product_id: String(productId || 'n/a'),
          added_product_title: String(title || 'n/a'),
          added_product_type: String(productType || 'n/a'),
          added_product_price: String(addedProductPrice || 'n/a'),
          added_product_quantity: String(addedProductQuantity || 'n/a'), 
          cart_value_before: String(cartValueBefore || 'n/a'),
          cart_value_after: String(cartValueAfter || 'n/a'),
          revenue_attributed: String(revenueAttributed || 'n/a'),
          timestamp: new Date().toISOString()
        };
        Shopify.analytics.publish('fast_simon_add_to_cart', eventData);
      } catch (error) {
        console.error('Error in add to cart tracking:', error);
      }
      isTrackingAddToCart = false;
    }, 100);
  }

  // Track upsell product clicks via Fast Simon widget hook
  // Hook element is detached from document body, so we bind mousedown directly on it
  function initUpsellClickTracking() {
    function reg() {
      window.FastRecommendationWidget.registerHook('upsell-cross-sell-products', ({ data, element }) => {
        if (element.__fsClickBound) return;
        element.__fsClickBound = true;

        element.addEventListener('mousedown', function (e) {
          var card = e.target.closest('.product-container[data-id]');
          if (!card) return;

          var productId = card.getAttribute('data-id') || 'n/a';
          var skuId = card.getAttribute('data-sku-id') || 'n/a';

          var titleEl = card.querySelector('.fs-recommendation-product-title');
          var productTitle = titleEl ? (titleEl.getAttribute('aria-label') || titleEl.textContent?.trim() || 'n/a') : 'n/a';

          // Determine widget_type by checking composedPath for cart drawer
          var widgetType = 'pdp';
          var path = e.composedPath ? e.composedPath() : [];
          for (var i = 0; i < path.length; i++) {
            if (path[i].id === 'CartDrawer') {
              widgetType = 'minicart';
              break;
            }
          }

          // Source product from the current page context
          var sourceProductId = 'n/a';
          var sourceProductTitle = 'n/a';
          var metaProduct = window.ShopifyAnalytics?.meta?.product;
          if (metaProduct) {
            sourceProductId = String(metaProduct.id || 'n/a');
          } else if (lastAddedProduct) {
            sourceProductId = String(lastAddedProduct.id || 'n/a');
          }
          if (window._conv_product_name) {
            sourceProductTitle = String(window._conv_product_name);
          } else if (metaProduct?.title) {
            sourceProductTitle = String(metaProduct.title);
          } else if (lastAddedProduct?.title) {
            sourceProductTitle = String(lastAddedProduct.title);
          }

          // console.log('[FS-CLICK] Upsell click:', JSON.stringify(eventData));
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'fast_simon_upsell_click',
            widget_type: widgetType,
            source_product_id: sourceProductId,
            source_product_title: sourceProductTitle,
            product_id: String(productId),
            product_sku: String(skuId),
            product_title: String(productTitle)
          });
        }, true);
      });
    }

    if (window.FastRecommendationWidget) {
      reg();
    } else {
      window.addEventListener('fast-upsell-cross-sell-ready', reg, { once: true });
    }
  }

  // Initialize event listeners
  function initEventListeners() {
    if (isInitialized) {
      // console.log('Event listeners already initialized');
      return;
    }
    // console.log('Initializing event listeners');
    isInitialized = true;

    // Track last added product for upsell click source on non-PDP pages
    // ajaxProduct:added fires for standard form-based ATC (PDP)
    document.addEventListener('ajaxProduct:added', function(evt) {
      var product = evt.detail && evt.detail.product;
      if (product) {
        lastAddedProduct = { id: product.product_id, title: product.title };
      }
    });
    // cart:open fires for all ATC paths (sliders, bundles, etc.)
    // Fetch cart to get last added item when ajaxProduct:added wasn't dispatched
    document.addEventListener('cart:open', function() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          if (cart.items && cart.items.length > 0) {
            var last = cart.items[0];
            lastAddedProduct = { id: last.product_id, title: last.product_title };
          }
        })
        .catch(function() {});
    });

    // Listen for upsell add to cart event
    document.addEventListener('upsell-product-added-to-cart', trackAddToCart);
    // console.log('Added upsell-product-added-to-cart event listener');

    // Listen for widget impression events
    document.addEventListener('upsell-product-impression', trackWidgetImpressions);
    // console.log('Added upsell-product-impression event listener');

    // Register click tracking on Fast Simon upsell widgets
    initUpsellClickTracking();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    // console.log('DOM still loading, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', initEventListeners);
  } else {
    // console.log('DOM already loaded, initializing immediately');
    initEventListeners();
  }
})(); 